import { render, staticRenderFns } from "./PageFooterPlainDark.vue?vue&type=template&id=1dd3eab5&"
import script from "./PageFooterPlainDark.vue?vue&type=script&lang=js&"
export * from "./PageFooterPlainDark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports